// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"634":"a148244d","860":"b863ed99","894":"ef46412f"}[chunkId] + ".chunk.css";
};